export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const SHOW_PROFILE = "SHOW_PROFILE";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
